import { RiFileExcel2Fill } from "react-icons/ri";
import { SiApacheparquet } from "react-icons/si";
import { GrDocumentCsv } from "react-icons/gr";
import type { AllAvailableFiltersType, KeyOptionsAAgentType, KeyOptionsSourceTableType, KeyOptionsType } from "../components/masterComponents/Filters/FiltersType";
import { properties } from "./properties";
import type { FileIconMapType } from "./EntitiesType";

export const DEFAULT_OPEN_KEYS_SOURCE_TABLE: KeyOptionsSourceTableType[] = ["class_name", "tag"];
export const DEFAULT_OPEN_KEYS_AAGENT: KeyOptionsAAgentType[] = ["value", "class_name", "tag", "source"];
export const DEFAULT_OPEN_KEYS_RULES: KeyOptionsAAgentType[] = ["value", "class_name", "tag", "source"];
export const DEFAULT_OPEN_KEYS_STATISTICS: KeyOptionsAAgentType[] = ["class_name"];

export const ALL_AVAILABLE_FILTERS: AllAvailableFiltersType<KeyOptionsType>[] = [
    { key: "class_name", label: "Classification", type: "dropdown", filterCategory: "equal", valuesByDefault: [] },
    { key: "source", label: "State", type: "select", filterCategory: "equal", valuesByDefault: [] },
    { key: "value", label: "Characteristic Value", filterCategory: "all", type: "input", valuesByDefault: [] },
    { key: "tag", label: "Tag", type: "input", filterCategory: "all", shouldSplitInputText: true, valuesByDefault: [] },
    { key: "item", label: "Item", type: "input", filterCategory: "all", valuesByDefault: [] },
    { key: "description", label: "Description", filterCategory: "all", type: "input", valuesByDefault: [] },

];

export const FileIconMap: Record<string, FileIconMapType> = {
    xlsx: { icon: RiFileExcel2Fill, name: "xlsx", color: "green" },
    parquet : { icon: SiApacheparquet, name: "parquet", color: "#5ca4ec" },
    csv : { icon: GrDocumentCsv, name: "csv", color: "#67bb23" }
}

export const ANALYSIS_SOURCE_TAG = {
    llm: { color: "red", label: "Unverified" },
    finals: { color: "orange", label: "Verified" },
    validated: { color: "green", label: "Validated" },
};

export const STATUS_COLOR_MAP: Record<string, string> = {
    completed: "green",
    failed: "red",
    in_progress: "blue"
};

export const ALL_BATCHES = properties.allBatches.map(batch => ({
    key: batch,
    label: batch,
}));

export const BATCH_FIELD: Record<string, string> = {
  JDE: "jde",
  EP: "ep",
  SPI: "spi",
};

export const getBatchField = (batch: string) => {
  const parts = batch.split("_");
  const prefix = parts[0] === "FULL" ? parts[1] : parts[0];
  return prefix ? BATCH_FIELD[prefix] : undefined;
};
